// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"ed824f0f","154":"b9a67675","973":"a5022bf1"}[chunkId] + ".chunk.css";
};